
export default function About() {
  return (
    <section id="sobre" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="relative h-[500px] rounded-lg overflow-hidden">
              <img
                src="https://static.readdy.ai/image/21e19603d42babf1dc4380dbdbe591fa/f561059217882f54b3029ef9418fd253.jpeg"
                alt="Patrick Segers - Especialista em Investigação Empresarial"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div>
            <h3 className="text-4xl font-bold text-gray-900 mb-6">
              Sobre Patrick Segers
            </h3>
            
            <div className="space-y-4 text-gray-600 leading-relaxed">
              <p>
                Com anos de experiência em <strong>investigação empresarial</strong>, 
                Patrick Segers é especialista reconhecido em proteger empresas contra 
                fraudes, vazamentos e riscos internos.
              </p>
              
              <p>
                Sua abordagem combina técnicas modernas de <strong>investigação defensiva</strong> 
                com profundo conhecimento jurídico, garantindo que todas as evidências 
                coletadas sejam admissíveis legalmente.
              </p>
              
              <p>
                Especializado em <strong>investigação de funcionários</strong> e 
                <strong> investigação patrimonial</strong>, Patrick oferece soluções 
                discretas e eficazes para empresas que precisam de respostas confiáveis.
              </p>
            </div>

            <div className="mt-8 space-y-4">
              <div className="flex items-start">
                <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-shield-check-line text-teal-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Sigilo Profissional</h4>
                  <p className="text-gray-600 text-sm">
                    Todas as investigações são conduzidas com total confidencialidade 
                    e discrição.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-file-text-line text-teal-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Documentação Legal</h4>
                  <p className="text-gray-600 text-sm">
                    Relatórios detalhados e evidências admissíveis em processos judiciais.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-user-star-line text-teal-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Expertise Comprovada</h4>
                  <p className="text-gray-600 text-sm">
                    Anos de experiência resolvendo casos complexos de investigação empresarial.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-10 p-6 bg-gray-50 rounded-lg border border-gray-200">
              <h4 className="font-semibold text-gray-900 mb-4 flex items-center">
                <i className="ri-scales-3-line text-teal-600 mr-2"></i>
                Conformidade Legal
              </h4>
              <p className="text-sm text-gray-600 mb-3">
                Toda a atividade é realizada em estrita conformidade com as normas que 
                regulamentam o trabalho investigativo no Brasil, incluindo:
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5 flex-shrink-0"></i>
                  <span><strong>Lei 13.432/2017</strong> - Regulamenta a profissão de detetive particular</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5 flex-shrink-0"></i>
                  <span><strong>Provimento 188/2018 da OAB</strong> - Investigação defensiva</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5 flex-shrink-0"></i>
                  <span><strong>LGPD - Lei 13.709/2018</strong> - Segurança e sigilo no tratamento de dados</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5 flex-shrink-0"></i>
                  <span><strong>Constituição Federal Art. 5º</strong> (privacidade e intimidade)</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
